(function() {
   'use strict';


    angular
        .module('app')
        .directive('swiper', swiper);
    	swiper.$inject = ["$location","$timeout"];

        	function swiper($location,$timeout) {
			    return {
			        restrict: 'A',
		            
			        link: function ( scope, elem, attrs ) {
			        	$timeout(function()
			        	{
			        		console.log("SwiperON");
			        		  //$('body').addClass('viewing-favorits');
							  var swiper = new Swiper('.swiper-container', {
							      pagination: '.swiper-pagination',
							      nextButton: '.swiper-button-next',
							      prevButton: '.swiper-button-prev',
							      //effect: 'coverflow',
							      loop:true,
							      grabCursor: false,
							      centeredSlides: true,
							      initialSlide : 0,
							      spaceBetween: 50,
							      slidesPerView: '3',
										simulateTouch : false,
							      coverflow: {
								      rotate: 0,
								      stretch: 0,
								      depth: 100,
								      modifier: 1,
								      slideShadows : false,
							
							
							  },
							  breakpoints: {
							    // when window width is <= 768px
							    768: {
							    slidesPerView: 1,
							    spaceBetween: 10,
									simulateTouch : true,
							    }
							  },
							});


			        	});
			        	
			        }
			    };
			}


})();
